import React, { useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import { IOnUpdateCatalogDTO } from "../../../../models/DTO/IOnUpdateCatalogDTO";
import IOrderRowConfig from "../../../../models/DTO/IOrderRowConfig";
import { IUpdateCatalogDTO } from "../../../../models/DTO/IUpdateCatalogDTO";
import ICatalog from "../../../../models/ICatalog";
import INotification from "../../../../models/INotification";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import WhatsThis from "../../../shared/WhatsThis/WhatsThis";
import { DragDropContext, Draggable, DraggableLocation, Droppable, DropResult, ResponderProvided } from "@hello-pangea/dnd";
import * as _ from "lodash-es";
import "./OrderRowConfig.scss";
import { Socket } from "socket.io-client";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import OrderRowColPropertyEnum from "../../../../models/OrderRowColPropertyEnum";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";

type Props = {
    socket: Socket;
    catalogModel: ICatalog;
    toggleOrderRowConfig: () => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const OrderRowConfig = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const getDefaultOrderRowConfig = (): IOrderRowConfig[] => {
        return [
            {
                property: OrderRowColPropertyEnum.ACTIONS,
                sequence: 1,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.ITEM_NO,
                sequence: 2,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.QTY,
                sequence: 3,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.SKU,
                sequence: 4,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.NAME,
                sequence: 5,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.DESCRIPTION,
                sequence: 6,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.PRICE_PER_UNIT,
                sequence: 7,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.ROW_TOTAL,
                sequence: 8,
                func: "",
            },
        ];
    };

    const getAllOrderRowConfig = (): IOrderRowConfig[] => {
        const rowConfig: IOrderRowConfig[] = [
            {
                property: OrderRowColPropertyEnum.ACTIONS,
                sequence: 1,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.ITEM_NO,
                sequence: 2,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.QTY,
                sequence: 3,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.SKU,
                sequence: 4,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.NAME,
                sequence: 5,
                func: "",
            },
            // {
            //     property: OrderRowColPropertyEnum.SHORT_DESCRIPTION,
            //     sequence: 6,
            //     func: "",
            // },
            {
                property: OrderRowColPropertyEnum.DESCRIPTION,
                sequence: 6,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.UNIT_OF_MEASURE,
                sequence: 7,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.COLOR,
                sequence: 8,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.STYLE,
                sequence: 9,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.LOCATION,
                sequence: 9,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.LIST_PRICE,
                sequence: 10,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.COST_PRICE,
                sequence: 11,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.NET_PRICE,
                sequence: 11,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.PRICE_PER_UNIT,
                sequence: 12,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.ROW_TOTAL,
                sequence: 13,
                func: "",
            },
            {
                property: OrderRowColPropertyEnum.COST_PER_UOM,
                sequence: 13,
                func: "",
            },
        ];

        if (supplierModel.has_map) {
            rowConfig.push({
                property: OrderRowColPropertyEnum.MAP,
                sequence: 14,
                func: "",
            });
        }

        if (supplierModel.has_discounts) {
            rowConfig.push({
                property: OrderRowColPropertyEnum.DISCOUNT,
                sequence: 14,
                func: "",
            });
        }

        if (supplierModel.has_dimensions) {
            rowConfig.push(
                {
                    property: OrderRowColPropertyEnum.WIDTH,
                    sequence: 13,
                    func: "",
                },
                {
                    property: OrderRowColPropertyEnum.HEIGHT,
                    sequence: 14,
                    func: "",
                },
                {
                    property: OrderRowColPropertyEnum.DEPTH,
                    sequence: 15,
                    func: "",
                }
            );
        }

        if (supplierModel.allow_item_price_group_override) {
            rowConfig.push({
                property: OrderRowColPropertyEnum.ITEM_PRICE_GROUP,
                sequence: 16,
                func: "",
            });
        }

        if (supplierModel.allow_manual_uom_base_qty) {
            rowConfig.push({
                property: OrderRowColPropertyEnum.UOM_BASE_QTY,
                sequence: 17,
                func: "",
            });
        }

        rowConfig.push({
            property: OrderRowColPropertyEnum.MSRP,
            sequence: 18,
            func: "",
        });

        rowConfig.push({
            property: OrderRowColPropertyEnum.ITEM_OPTIONS,
            sequence: 19,
            func: "",
        });

        return rowConfig;
    };

    /**
     * @deprecated
     */
    const getFilteredAvailableColumns = (order_row_config: IOrderRowConfig[]): IOrderRowConfig[] => {
        const all_order_row_config = getAllOrderRowConfig();
        const filtered_order_row_config: IOrderRowConfig[] = [];

        // filter out any selected items from order_row_config
        for (const all_row_config_item of all_order_row_config) {
            let found = false;

            for (const selected_row_config_item of order_row_config) {
                if (selected_row_config_item.property === all_row_config_item.property) {
                    found = true;
                }
            }

            if (!found) {
                filtered_order_row_config.push(all_row_config_item);
            }
        }

        return filtered_order_row_config;
    };

    const getOrderRowConfig = (): IOrderRowConfig[] => {
        let orderRowConfig = props.catalogModel.order_row_config || ([] as IOrderRowConfig[]);

        if (!orderRowConfig.length) {
            orderRowConfig = getDefaultOrderRowConfig();
        }

        return orderRowConfig;
    };

    const getAvailableItems = () => {
        const order_row_config = getOrderRowConfig();
        const all_order_row_config = getAllOrderRowConfig();
        const filtered_order_row_config: IOrderRowConfig[] = [];

        // filter out any selected items from order_row_config
        for (const all_row_config_item of all_order_row_config) {
            let found = false;

            for (const selected_row_config_item of order_row_config) {
                if (selected_row_config_item.property === all_row_config_item.property) {
                    found = true;
                }
            }

            if (!found) {
                filtered_order_row_config.push(all_row_config_item);
            }
        }

        return filtered_order_row_config;
    };

    const [hasUnsavedChange, setHasUnsavedChange] = useState(false);
    const [selectedItems, setSelectedItems] = useState<IOrderRowConfig[]>(getOrderRowConfig());
    const [availableItems, setAvailableItems] = useState(getAvailableItems());
    const [catalogModel, setCatalogModel] = useState(props.catalogModel);
    const [saveActive, setSaveActive] = useState(false);

    const updateCatalog = () => {
        const payload: IUpdateCatalogDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            catalogGuid: catalogModel.guid,
            active: catalogModel.active,
            version: catalogModel.version,
            name: catalogModel.name,
            order_row_config: selectedItems,
        };

        props.socket.emit(EndpointsEnum.CatalogsUpdateCatalog, payload);

        setSaveActive(true);
    };

    const onUpdateCatalog = (data: IOnUpdateCatalogDTO) => {
        const notification: INotification = {
            message: "order_row_config_updated",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);

        setSaveActive(false);
        setCatalogModel(data.catalog);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.CatalogsOnUpdateCatalog, fn: onUpdateCatalog }];

    useEffect(() => {
        for (const socket of sockets) {
            props.socket.on(socket.endpoint, socket.fn);
        }

        return () => {
            for (const socket of sockets) {
                props.socket.removeListener(socket.endpoint, socket.fn);
            }
        };
    }, []);

    const afterOpenModal = () => {};

    const onDragStart = (start: any) => {
        console.log("Drag started:", start);
    };

    const onOrderRowConfigDragEnd = (result: DropResult, provided: ResponderProvided) => {
        const { source, destination } = result;

        console.log("Drag end result:", result);
        console.log("Drag type:", result.type);
        console.log("Draggable ID:", result.draggableId);
        console.log("Source droppableId:", source.droppableId);
        console.log(
            "Selected items:",
            selectedItems.map((item) => ({ id: `selected-${item.property}`, property: item.property }))
        );
        console.log(
            "Available items:",
            availableItems.map((item) => ({ id: `available-${item.property}`, property: item.property }))
        );

        if (!destination) {
            return;
        }

        if (source.droppableId === destination.droppableId) {
            let listId = "selectedItems";
            let list: IOrderRowConfig[] = selectedItems;

            if (source.droppableId === "availableItems") {
                listId = "availableItems";
                list = availableItems;
            }

            // We don't allow anything other than Preliminary to be in the first spot
            if (destination.index === 0 || source.index === 0) {
                return;
            }

            const items = reorder(list, source.index, destination.index);

            if (source.droppableId === "selectedItems") {
                setSelectedItems(items);
            } else {
                setAvailableItems(items);
            }
        } else {
            const sourceItems: IOrderRowConfig[] = source.droppableId === "availableItems" ? availableItems : selectedItems;
            const destinationItems: IOrderRowConfig[] = destination.droppableId === "availableItems" ? availableItems : selectedItems;

            const result = move(sourceItems, destinationItems, source, destination);

            if (source.droppableId === "selectedItems") {
                setSelectedItems(result.sourceItems);
                setAvailableItems(result.destItems);
            } else {
                setAvailableItems(result.sourceItems);
                setSelectedItems(result.destItems);
            }
        }
    };

    const reorder = (list: IOrderRowConfig[], startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const move = (
        source: IOrderRowConfig[],
        destination: IOrderRowConfig[],
        droppableSource: DraggableLocation,
        droppableDestination: DraggableLocation
    ) => {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);

        destClone.splice(droppableDestination.index, 0, removed);

        const result: any = {
            sourceItems: sourceClone,
            destItems: destClone,
        };
        // result[droppableSource.droppableId] = sourceClone;
        // result[droppableDestination.droppableId] = destClone;

        return result;
    };

    const handleChange = (e: any, index: number) => {
        const checked = e.target.value;

        const order_row_config = [...selectedItems];

        order_row_config[index].isSupplierUserEditable = checked;

        setSelectedItems(order_row_config);
    };

    return (
        <div className={"w-100 OrderRowConfig"}>
            <div>
                <div>
                    <div className={"d-flex"}>
                        <div className={"d-flex align-items-center"}>
                            <OwTitle className={"me-auto"} leftIconName={"fad fa-columns"} title={"order_row_config"} tag={"h3"} />
                            <div className={"ms-2"}>
                                <OwButton title={"save"} fn={updateCatalog} active={saveActive} disableOnActive={true} />
                            </div>
                        </div>

                        <div className={"ms-auto"}>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.toggleOrderRowConfig} />
                        </div>
                    </div>

                    <WhatsThis subject={"order_row_config_blurb"} />
                </div>
            </div>
            <DragDropContext
                onDragStart={onDragStart}
                onDragEnd={onOrderRowConfigDragEnd}
                onBeforeDragStart={(initial) => console.log("Before drag start:", initial)}
                onDragUpdate={(update) => console.log("Drag update:", update)}>
                <OwTitle title={"selected_columns"} tag={"h5"} />
                <Droppable
                    droppableId="selectedItems"
                    direction={"horizontal"}
                    isDropDisabled={false}
                    isCombineEnabled={false}
                    ignoreContainerClipping={true}>
                    {(provided, snapshot) => (
                        <div
                            className={
                                "d-flex border border-secondary droppable-container-row " + (snapshot.isDraggingOver ? "dragging-over" : "")
                            }
                            ref={provided.innerRef}>
                            {selectedItems.map((columnDetail, index) => {
                                // Use property-based IDs that are stable and unique
                                const itemId = `selected-${columnDetail.property}`;
                                return (
                                    <Draggable
                                        draggableId={itemId}
                                        index={index}
                                        key={itemId}
                                        isDragDisabled={columnDetail.property === OrderRowColPropertyEnum.ACTIONS}>
                                        {(providedInner, snapshotInner, rubricInner) => (
                                            <div
                                                className={
                                                    "order-row-config-item " +
                                                    (columnDetail.property === OrderRowColPropertyEnum.ACTIONS
                                                        ? "not-allowed"
                                                        : "grab-cursor") +
                                                    (snapshotInner.isDragging ? " dragging" : "")
                                                }
                                                ref={providedInner.innerRef}
                                                {...providedInner.draggableProps}
                                                style={{
                                                    ...providedInner.draggableProps.style,
                                                    boxShadow: snapshotInner.isDragging ? "0 0 0.5rem rgba(0, 0, 0, 0.2)" : "none",
                                                }}>
                                                <div className={"drag-handles"} {...providedInner.dragHandleProps}>
                                                    <i className={"fas fa-grip-horizontal"}></i>
                                                </div>
                                                <div>{/*<OwPill title={`${index+1}`} skipTranslate={true} />*/}</div>
                                                <div>
                                                    <OwLabel
                                                        title={_.snakeCase(columnDetail.property)}
                                                        noBottomMargin={true}
                                                        leftIconClass={
                                                            columnDetail.property === OrderRowColPropertyEnum.ACTIONS ? "fad fa-lock" : ""
                                                        }
                                                    />
                                                </div>
                                                <div>
                                                    <OwCheckbox
                                                        label={"supplier_editable"}
                                                        checked={columnDetail.isSupplierUserEditable}
                                                        name={"isSupplierUserEditable"}
                                                        fn={(e: any) => {
                                                            handleChange(e, index);
                                                        }}
                                                        truthyVal={true}
                                                        falsyVal={false}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                );
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                {/* Filtered Master List */}
                <OwTitle title={"available_columns"} tag={"h5"} />
                <Droppable
                    droppableId="availableItems"
                    direction={"horizontal"}
                    isDropDisabled={false}
                    isCombineEnabled={false}
                    ignoreContainerClipping={true}>
                    {(provided, snapshot) => (
                        <div
                            className={
                                "d-flex border border-secondary droppable-container-row " + (snapshot.isDraggingOver ? "dragging-over" : "")
                            }
                            ref={provided.innerRef}>
                            {availableItems.map((columnDetail, index) => {
                                // Use property-based IDs that are stable and unique
                                const itemId = `available-${columnDetail.property}`;
                                return (
                                    <Draggable draggableId={itemId} index={index} key={itemId}>
                                        {(providedInner, snapshotInner, rubricInner) => (
                                            <div
                                                className={
                                                    "order-row-config-item grab-cursor" + (snapshotInner.isDragging ? " dragging" : "")
                                                }
                                                ref={providedInner.innerRef}
                                                {...providedInner.draggableProps}
                                                style={{
                                                    ...providedInner.draggableProps.style,
                                                    boxShadow: snapshotInner.isDragging ? "0 0 0.5rem rgba(0, 0, 0, 0.2)" : "none",
                                                }}>
                                                <div className={"drag-handles"} {...providedInner.dragHandleProps}>
                                                    <i className={"fas fa-grip-horizontal"}></i>
                                                </div>
                                                <div>{/*<OwPill title={`${index+1}`} skipTranslate={true} />*/}</div>
                                                <div>
                                                    <OwLabel title={_.snakeCase(columnDetail.property)} noBottomMargin={true} />
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                );
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
};

export default OrderRowConfig;
